import * as types from "./actionTypes";
import initialState from "./initialState";

export default function reducer(state = initialState, { type, payload } = {}) {
  switch (type) {
    case types.APP_MODE_API_MODAL:
      return { ...state, apiModalShow: payload ?? payload };
    default:
      return state;
  }
}
